<template>
  <b-form>
    <b-row>
      <template v-for="field in this.fields">
        <b-col :cols="field.width" v-bind:key="field.name">
          <b-button v-if="field.type === 'header' && field.backButton " class="float-right" @click="$router.go(-1)">{{ $t('back') }}</b-button>
          <h5 v-if="field.type === 'header'">{{ field.displayName }}</h5>

          <b-form-input v-else-if="field.type === 'hidden'" v-model="stateObject[field.name]" hidden :placeholder="field.placeholder"/>

          <div v-else-if="field.type === 'empty'"/>

          <b-form-group v-else :label="createLabel(field)" :for="field.name">
            <b-input-group v-if="field.type === 'text'">
              <b-form-input :id="field.name" v-model="stateObject[field.name]" :readonly="field.readonly" :placeholder="field.placeholder"
                            :autofocus="field.autofocus" data-lpignore="true" style="text-overflow: ellipsis;"/>
              <b-input-group-prepend v-if="field.appendIcon === 'organizationSearch'">
                <span class="input-group-text"><b-icon-search font-scale="1.5" @click="$emit('searchSchool') "/></span>
              </b-input-group-prepend>
              <b-input-group-prepend v-if="field.appendIcon === 'searchUser'">
                <span class="input-group-text"><b-icon-search font-scale="1.5" @click="$emit('searchUser') "/></span>
              </b-input-group-prepend>
              <b-input-group-prepend v-if="field.appendIcon === 'productSearch'">
                <span class="input-group-text"><b-icon-search font-scale="1.5" @click="$emit('searchProduct') "/></span>
              </b-input-group-prepend>
            </b-input-group>

            <b-form-textarea v-else-if="field.type === 'textarea'" :readonly="field.readonly"
                             :id="field.name" v-model="stateObject[field.name]" :autofocus="field.autofocus"/>

            <div v-else-if="field.type === 'textarray'" class="form-control" v-for="item in stateObject[field.name]" :key="item" readonly>
              {{ item }}
            </div>

            <div v-else-if="field.type === 'url'" class="form-control" readonly>
              <a :href=stateObject[field.name] target="_blank">{{ stateObject[field.name] }}</a>
            </div>

            <!-- FIXME This should be editable. But how to edit an ISO 8061 duration..? -->
            <b-form-input v-else-if="field.type === 'duration'" :readonly="field.readonly"
                          :id=field.name v-model="stateObject[field.name]"/>

            <b-form-input v-else-if="field.type === 'number'" :readonly="field.readonly" type="number"
                          :id=field.name v-model="stateObject[field.name]"/>

            <b-form-tags v-else-if="field.type === 'tags'" :disabled="field.readonly"
                         separator=" ,;" placeholder=""
                         :id="field.name" v-model="stateObject[field.name]"/>

            <b-form-select v-else-if="field.type === 'dropdown'" :disabled="field.readonly"
                           :id="field.name" v-model="stateObject[field.name]" :options="field.items"
                           :multiple="field.multiple" :select-size="field.selectSize">
              <template v-if="field.appendToolTip">
                <font-awesome-icon :id="field.name" icon="info-circle"/>
                <b-tooltip :target="field.name">{{ $t(field.toolTip) }}</b-tooltip>
              </template>
            </b-form-select>

            <b-form-input v-if="field.type === 'color'" :disabled="field.readonly" type="color"
                          :id="field.name" v-model="stateObject[field.name]"/>

            <b-form-datepicker v-else-if="field.type === 'date'" :disabled="field.readonly"
                               :locale="langCode"
                               :label-reset-button="$t('reset')" reset-button
                               :placeholder="$t('chooseADate')"
                               v-model="stateObject[field.name]"/>

            <b-form-checkbox v-else-if="field.type === 'boolean'" :disabled="field.readonly"
                             v-model="stateObject[field.name]" switch>
              {{ stateObject[field.name] ? $t('yes') : $t('no') }}
            </b-form-checkbox>

            <div v-else-if="field.type === 'address'" :readonly="field.readonly" :id="field.name">
              <p class="aco-multiline-text"> {{ stateObject[field.name].addressLine1 }} <br/>
                <span v-if="stateObject[field.name].addressLine2">
                  {{stateObject[field.name].addressLine2}}<br/>
                </span>
                {{stateObject[field.name].postalCode}} {{stateObject[field.name].city}}<br/>
                {{stateObject[field.name].country}}<br/>
              </p>
            </div>

            <div v-if="field.type === 'schoolOrganization' && stateObject.schoolOrganizations && stateObject.schoolOrganizations.length >= 1" :id="field.name">
              <span>{{ stateObject.schoolOrganizations.length === 1 ? $t('school') : $t('schools')}}</span>
              <div id="editSchoolTip" v-for="(schoolOrganization ) in stateObject.schoolOrganizations" class="form-control" :readonly="field.readonly" v-bind:key="schoolOrganization.number" >
                {{schoolOrganization.name}} ({{schoolOrganization.number}})
                <template v-if="field.appendIcon === 'organizationEdit'">
                  <b-icon-pencil-square font-scale="1.5" @click="$emit('searchSchool')"/>
                  <b-tooltip target="editSchoolTip">{{ $t('toolTip.editSchoolTip')}}</b-tooltip>
                </template>
              </div>
            </div>

            <div v-if="field.type === 'homeOrganization' && stateObject.homeOrganization" class="form-control" :readonly="field.readonly" :id="field.name">
              {{stateObject[field.name].name}} ({{stateObject[field.name].number}})
            </div>

          </b-form-group>
        </b-col>
      </template>
    </b-row>
  </b-form>
</template>

<script>
  import BaseComponent from './BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DetailsForm',
    extends: BaseComponent,
    props: {
      fields: { type: Array },
      stateObject: { type: Object }
    },
    computed: {
      ...mapGetters('languageStore', ['langCode']),
    },
    methods: {
      createLabel (field) {
        let displayName = field.displayName ? field.displayName : this.$t(field.name)
        if (field.required) {
          return displayName + ' *'
        } else {
          return displayName
        }
      }
    }
  }
</script>
